const routes = [
    {
        path: "/30/bybt",
        children: [
            {
                path: "tenasjhdaj",
                component: () => import("@/views/30/bybt/index.vue"),
                meta: {
                    sign: "tenThousand",
                },
            },
            {
                path: "fivejsdsss",
                component: () => import("@/views/30/bybt/index.vue"),
                meta: {
                    sign: "fiveThousand",
                },
            },
            {
                path: "twentypiojhi",
                component: () => import("@/views/30/bybt/index.vue"),
                meta: {
                    sign: "twentyThousand",
                },
            },
            {
                path: "yhqhjkuy",
                component: () => import("@/views/30/bybt/index.vue"),
                meta: {
                    sign: "deyhq",
                },
            },
            {
                path: "twenty11236",
                component: () => import("@/views/30/bybt/index3.vue"),
                meta: {
                    sign: "twenty11236",
                },
            },
            {
                path: "ten1508",
                component: () => import("@/views/30/bybt/index3.vue"),
                meta: {
                    sign: "ten1508",
                },
            },            {
                path: "five1876",
                component: () => import("@/views/30/bybt/index3.vue"),
                meta: {
                    sign: "five1876",
                },
            },            {
                path: "yhq3779",
                component: () => import("@/views/30/bybt/index3.vue"),
                meta: {
                    sign: "yhq3779",
                },
            },
        ],
    },
];

export default routes;
